import R from 'ramda';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Form, FormGroup, FormControl } from 'react-bootstrap';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import { WORK_SUB_TYPE_MUSICAL_COMPOSITION_SOUND_RECORDING } from '../../constants';

class CregType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      subWorkTypes: [],
    };
  }

  componentWillMount() {
    const { workTypes, fields, profile } = this.props;
    this.handleSubWorkType(-1);

    if (fields.type) {
      this.loadSubWorkTypes(parseInt(fields.type, 10));
    } else if (workTypes && workTypes.length) {
      this.loadSubWorkTypes(workTypes[0].id);
    }

    this.props.loadTeams();

    if (profile && profile.id) {
      this.props.loadDeals(profile.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { profile } = nextProps;

    if (profile && profile.id !== this.props.profile.id) {
      this.props.loadDeals(profile.id);
    }
  }

  loadSubWorkTypes(workType) {
    const { subWorkTypes } = this.props;
    let filters = R.filter((subWorkType) => subWorkType.work_type === workType)(
      subWorkTypes
    );
    filters = _.orderBy(filters, ['id'], ['asc']);

    this.setState({ subWorkTypes: filters });
  }

  handleSubWorkType(subWorkType) {
    this.props.assignAttribute('subType', subWorkType);
  }

  handleNext() {
    const { fields } = this.props;

    this.props.hideAlert();

    if (!fields.subType) {
      this.props.alert('error', 'Please check the required fields.');
    } else {
      this.props.router.push('/copyright-reg/work-type');
    }
  }

  render() {
    const { fields } = this.props;
    const { subWorkTypes } = this.state;

    return (
      <div className="select-work copyright-work">
        <Heading text="What type of copyright are you registering?" />
        <br />
        <div className="content">
          <Form>
            <FormGroup>
              <Row>
                <Col sm={12}>
                  <FormControl
                    componentClass="select"
                    value={fields.subType === undefined ? -1 : fields.subType}
                    onChange={(e) => this.handleSubWorkType(e.target.value)}
                  >
                    <option disabled key={-1} value={-1}>
                      Select One
                    </option>
                    {subWorkTypes.map((subWorkType, i) => (
                      <option key={i} value={subWorkType.id}>
                        {subWorkType.name}
                      </option>
                    ))}
                  </FormControl>
                  <br />
                  {fields.subType ===
                    WORK_SUB_TYPE_MUSICAL_COMPOSITION_SOUND_RECORDING && (
                    <div>
                      To register compositions and sound recordings on the same
                      application, all of the authors must have created both and
                      the claimants (owners) must also own both. If this is not
                      the case, you will have to register the compositions and
                      sound recordings on separate applications.
                    </div>
                  )}
                </Col>
              </Row>
            </FormGroup>
          </Form>
        </div>
        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.push('/copyright-reg')}
          />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  fields: state.coreg.fields,
  subWorkTypes: state.global.subWorkTypesCoreg,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
  loadTeams: () => {
    dispatch(actions.getTeams());
  },
  loadDeals: (userId) => {
    dispatch(actions.getUserDeals(userId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CregType);



// WEBPACK FOOTER //
// src/components/Copyright/CregType.jsx